var $44c4277f10c34db0$exports = {};
$44c4277f10c34db0$exports = {
    "loading": `Ladataan\u{2026}`,
    "loadingMore": `Ladataan lis\xe4\xe4\u{2026}`
};


export {$44c4277f10c34db0$exports as default};
//# sourceMappingURL=fi-FI.mjs.map
